import { Color } from "../enums/Color";

export const diplomaListPage = {    
    mobile: {
        accordionButtonsContainer: {            
            display: "flex",
            justifyContent: "center",
            marginTop: "70px"
        },
        accordionButton: {
            height: "8.42vw",
            width: "32vw",
            border: "2px solid " + Color.DarkAsh,                        
            fontWeight: "bold",
            fontSize: "3.83vw",
            backgroundColor: Color.White,
            color: Color.SharpAsh,
            textAlign: "center" as "center",
            cursor: "pointer",
            letterSpacing: "0",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            WebkitTapHighlightColor : "transparent",            
            left: {                
                borderRadius: "5px 0px 0px 5px"
            },
            right: {
                borderRadius: "0px 5px 5px 0px"
            },
            selected: {
                border: "2px solid " + Color.DeepBlack,
                color: Color.White,
                backgroundColor: Color.DeepBlack,
                fontWeight: "500"
            }
        }
    },
    desktop: {
        margin: "16px 4% 0 4%",
        accordionButtonsContainer: {            
            marginTop: "0.83vw"
        },
        accordionButton: {
            height: "2.6vw",
            width: "20vw",
            fontSize: "1.2vw",
            fontWeight: "500",
            left: {                
                borderRadius: "0.52vw 0px 0px 0.52vw"
            },
            right: {                
                borderRadius: "0px 0.52vw 0.52vw 0px"
            },
            selected: {                
                fontWeight: "bold"
            }
        },   
        searchWrapper: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            marginTop: "2.18vw"
        },
        searchSelect: {        
            wrapper: {   
                width: "20vw",            
                marginLeft: "unset"          
            },
            label: {
                fontSize: "1.20vw"
            },
            hover: {
                width: "19.48vw",
                height: "17.70vw",
                left: "unset",
                padding: "0.26vw 0.26vw 1.04vw 0.26vw"
            }
        },
        searchInput: {
            height: "2.66vw",
            width: "20vw",
            padding: "0 0.625vw",                    
            fontSize: "1.20vw",
            border: "2px solid " + Color.Green,
            borderRadius: "0.52vw"     
        },
        table: {
            width: "-webkit-fill-available",
            margin: "24px 0 0 0",
            border: "2px solid " + Color.Green,
            borderCollapse: "collapse",
            header: {
                height: "48px",
                backgroundColor: Color.Green,
                color: Color.White
            },
            tr: {
                height: "5.20vw",
                border: "2px solid " + Color.Green,
                borderCollapse: "collapse",                
                textAlign: "center"
            },
            hoveredTr: {
                height: "8.33vw",
                backgroundColor: Color.LightAsh,
                cursor: "pointer"
            },
            idColumn: {
                width: "8%"
            },
            instituteColumn: {
                width: "20%"
            },            
            diplomaColumn: {
                width: "30%"
            },            
            periodColumn: {
                width: "12%"
            },             
            periodCell: {
                position: "relative"
            },
            rowWrapper: {
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center"
            },
            logo: {
                height: "50px",
                width: "50px",
                margin: "10px",
                objectFit: "contain"
            },
            editButton: {
                position: "absolute",
                height: "1.67vw",
                width: "6.14vw",
                border: "3px solid " + Color.MediumGreen,
                borderRadius: "0.26vw",
                right: "0.72vw",
                bottom: "0.72vw"
            }              
        }              
    }
}